/* eslint-disable react/react-in-jsx-scope */
/* -------------------------------------------------------------------------- */
/*                                Configuration                                 */
/* -------------------------------------------------------------------------- */
import React from 'react';
import ScopeFilterOperators from 'ui/components/DataGrid/Filters/ScopeFilter/ScopeFilter';
import ActiveFilterOperators from 'ui/components/DataGrid/Filters/ActiveFilter/ActiveFilter';
import TypeFilterOperators from 'ui/components/DataGrid/Filters/TypeFilter/TypeFilter';
import LanguageFilterOperators from 'ui/components/DataGrid/Filters/LanguageFilter/LanguageFilter';
import DateFilterOperators from 'ui/components/DataGrid/Filters/DateFilter/DateFilter';

/**
Table schema configuration for the module
@type {TableSchemaBase}
*/

const tableSchemaBase = [
  { field: 'user', headerName: 'name', width: 220, fontSize: '2px', type: 'user', resizable: true },
  {
    field: 'subscriptionsCount',
    headerName: 'programs_in_progress',
    type: 'text',
    minWidth: 130,
    resizable: true,
    flex: 1,
  },
  {
    field: 'active',
    headerName: 'activated',
    type: 'text',
    filterOperators: ActiveFilterOperators,
    minWidth: 100,
    resizable: true,
    flex: 1,
  },
  {
    field: 'internalCoach',
    headerName: 'type',
    type: 'text',
    minWidth: 120,
    filterOperators: TypeFilterOperators,
    resizable: true,
    flex: 1,
  },
  {
    field: 'scopeName',
    headerName: 'scope',
    type: 'text',
    width: 180,
    filterOperators: ScopeFilterOperators,
    resizable: true,
  },
  {
    field: 'registrationDate',
    headerName: 'registration_date',
    resizable: true,
    minWidth: 180,
    type: 'text',
    flex: 1,

    filterOperators: DateFilterOperators,
  },
  {
    field: 'languagesSpoken',
    headerName: 'languages',
    type: 'languages',
    width: 180,
    filterOperators: LanguageFilterOperators,
    resizable: true,
  },
  {
    field: 'actions',
    headerName: 'actions',
    sortable: false,
    minWidth: 120,
    filter: false,
    filterable: false,
    valueGetter: (params) => `${params.row.firstName || ''} ${params.row.lastName || ''}`,
    type: 'actionsExperts',
    headerAlign: 'center',
    align: 'center',
    flex: 1,

    resizable: true,
  },
];

export { tableSchemaBase };
